import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication
} from '@azure/msal-browser';
import { AccessDeniedComponent } from '@core/authentication/components/access-denied/access-denied.component';
import { AUTH_CONFIG } from '@core/config/config.service';
import { IAuthConfig } from '@env/IEnvironment';

export function MSALInstanceFactory(authConfig: IAuthConfig): IPublicClientApplication {
  return new PublicClientApplication({
    ...authConfig.config,
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage
    }
  });
}

export function MSALInterceptorConfigFactory(authConfig: IAuthConfig): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[]>();

  authConfig.angularConfig.protectedResourceMap.forEach(([uri, scopes]) => {
    protectedResourceMap.set(uri, scopes);
  });

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(authConfig: IAuthConfig): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...authConfig.angularConfig.consentScopes],
      ...authConfig.angularConfig.extraQueryParameters
    },
  };
}

@NgModule({
  declarations: [
    AccessDeniedComponent,
  ],
  imports: [
    CommonModule,
    MsalModule,
  ],
  providers: [
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [AUTH_CONFIG],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
      deps: [AUTH_CONFIG],
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
      deps: [AUTH_CONFIG],
    },
  ],
})
export class AuthenticationModule {}

